export default function dataLayer(event) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}
